import {
  LIBRARY_CATEGORIES_HUB_PAGE_REQUEST,
  LIBRARY_CATEGORIES_HUB_LIST_REQUEST,
  LIBRARY_CATEGORIES_HUB_SET_LIST_CATEGORIES,
  LIBRARY_CATEGORIES_HUB_ON_CLICK_ROW,
  LIBRARY_CATEGORIES_HUB_SET_CATEGORY_DETAIL,
  LIBRARY_CATEGORIES_HUB_ON_CLICK_CANCEL,
  LIBRARY_CATEGORIES_HUB_ON_CLICK_CREATE_CATEGORY,
  LIBRARY_CATEGORIES_HUB_SUBMIT_FORM_UPDATE,
  LIBRARY_CATEGORIES_HUB_SUBMIT_FORM_CREATE,
  LIBRARY_CATEGORIES_HUB_DELETE_CATEGORY_REQUEST,
  LIBRARY_CATEGORIES_HUB_SHOW_DELETE_MODAL,
  LIBRARY_CATEGORIES_HUB_HIDE_DELETE_MODAL,
  LIBRARY_CATEGORIES_HUB_DELETE_CATEGORY,
  LIBRARY_CATEGORIES_HUB_SET_DELETED_CATEGORY,
  LIBRARY_CATEGORIES_HUB_ON_CLICK_ASSIGN_TO_ITEM,
  LIBRARY_CATEGORIES_HUB_SHOW_ASSIGN_TO_ITEM_MODAL,
  LIBRARY_CATEGORIES_HUB_HIDE_ASSIGN_TO_ITEM_MODAL,
  LIBRARY_CATEGORIES_HUB_ASSIGN_TO_ITEM_SET_ITEMS,
  LIBRARY_CATEGORIES_HUB_ASSIGN_TO_ITEM_SET_META,
  LIBRARY_CATEGORIES_HUB_ASSIGN_TO_ITEM_GET_ITEMS_REQUEST,
  LIBRARY_CATEGORIES_HUB_SUBMIT_ASSIGN_TO_ITEM,
  LIBRARY_CATEGORIES_HUB_ASSIGN_TO_ITEM_FILL_FORM,
  LIBRARY_CATEGORIES_HUB_OPEN_RIGHT_COLUMN,
  LIBRARY_CATEGORIES_HUB_CLOSE_RIGHT_COLUMN,
  LIBRARY_CATEGORIES_HUB_IS_SUBMITTING_FORM,
  LIBRARY_CATEGORIES_HUB_SET_META_CATEGORIES,
  LIBRARY_CATEGORIES_HUB_SET_CHANNEL_ASYNC_JOB,
  LIBRARY_CATEGORIES_HUB_HANDLE_SUCCESS_ASYNC_JOB,
  LIBRARY_CATEGORIES_HUB_HANDLE_FAILED_ASYNC_JOB,
} from './constants';

export function pageRequest() {
  return { type: LIBRARY_CATEGORIES_HUB_PAGE_REQUEST };
}

export function categoriesRequest(params, previousCategories) {
  return {
    type: LIBRARY_CATEGORIES_HUB_LIST_REQUEST,
    payload: { params, previousCategories },
  };
}

export function setListCategories(categories) {
  return {
    type: LIBRARY_CATEGORIES_HUB_SET_LIST_CATEGORIES,
    payload: { categories },
  };
}

export const setMetaCategories = meta => {
  return {
    type: LIBRARY_CATEGORIES_HUB_SET_META_CATEGORIES,
    payload: { meta },
  };
};

export function onClickRow(category) {
  return { type: LIBRARY_CATEGORIES_HUB_ON_CLICK_ROW, payload: { category } };
}

export function setCategoryDetail(category) {
  return {
    type: LIBRARY_CATEGORIES_HUB_SET_CATEGORY_DETAIL,
    payload: { category },
  };
}

export function onClickCancel() {
  return { type: LIBRARY_CATEGORIES_HUB_ON_CLICK_CANCEL };
}

export function onClickCreateCategory() {
  return { type: LIBRARY_CATEGORIES_HUB_ON_CLICK_CREATE_CATEGORY };
}

export function submitFormUpdate(id, data, previousCategories) {
  return {
    type: LIBRARY_CATEGORIES_HUB_SUBMIT_FORM_UPDATE,
    payload: { id, data, previousCategories },
  };
}

export function submitFormCreate(data, previousCategories) {
  return {
    type: LIBRARY_CATEGORIES_HUB_SUBMIT_FORM_CREATE,
    payload: { data, previousCategories },
  };
}

export function setDeletedCategory(deletedCategory) {
  return {
    type: LIBRARY_CATEGORIES_HUB_SET_DELETED_CATEGORY,
    payload: { deletedCategory },
  };
}

export function deleteCategoryRequest(deletedCategory) {
  return {
    type: LIBRARY_CATEGORIES_HUB_DELETE_CATEGORY_REQUEST,
    payload: { deletedCategory },
  };
}

export function showDeleteModal() {
  return { type: LIBRARY_CATEGORIES_HUB_SHOW_DELETE_MODAL };
}

export function hideDeleteModal() {
  return { type: LIBRARY_CATEGORIES_HUB_HIDE_DELETE_MODAL };
}

export function deleteCategory(id, previousCategories) {
  return {
    type: LIBRARY_CATEGORIES_HUB_DELETE_CATEGORY,
    payload: { id, previousCategories },
  };
}

export function onClickAssignToItem(category) {
  return {
    type: LIBRARY_CATEGORIES_HUB_ON_CLICK_ASSIGN_TO_ITEM,
    payload: { category },
  };
}

export function showAssignToItemModal() {
  return {
    type: LIBRARY_CATEGORIES_HUB_SHOW_ASSIGN_TO_ITEM_MODAL,
  };
}

export function hideAssignToItemModal() {
  return {
    type: LIBRARY_CATEGORIES_HUB_HIDE_ASSIGN_TO_ITEM_MODAL,
  };
}

export function assignToItemSetItems(items) {
  return {
    type: LIBRARY_CATEGORIES_HUB_ASSIGN_TO_ITEM_SET_ITEMS,
    payload: { items },
  };
}

export const assignToItemSetMeta = meta => {
  return {
    type: LIBRARY_CATEGORIES_HUB_ASSIGN_TO_ITEM_SET_META,
    payload: { meta },
  };
};

export function assignToItemGetItemsRequest(params, previousItems) {
  return {
    type: LIBRARY_CATEGORIES_HUB_ASSIGN_TO_ITEM_GET_ITEMS_REQUEST,
    payload: { params, previousItems },
  };
}

export function submitAssignToItem(data, categoryId) {
  return {
    type: LIBRARY_CATEGORIES_HUB_SUBMIT_ASSIGN_TO_ITEM,
    payload: { data, categoryId },
  };
}

export function assignToItemFillForm(category) {
  return {
    type: LIBRARY_CATEGORIES_HUB_ASSIGN_TO_ITEM_FILL_FORM,
    payload: { category },
  };
}

export function openRightColumn() {
  return { type: LIBRARY_CATEGORIES_HUB_OPEN_RIGHT_COLUMN };
}

export function closeRightColumn() {
  return { type: LIBRARY_CATEGORIES_HUB_CLOSE_RIGHT_COLUMN };
}

export function isSubmittingForm(isSubmittingForm) {
  return {
    type: LIBRARY_CATEGORIES_HUB_IS_SUBMITTING_FORM,
    payload: { isSubmittingForm },
  };
}

export function setEventAsyncJob(channelName) {
  return {
    type: LIBRARY_CATEGORIES_HUB_SET_CHANNEL_ASYNC_JOB,
    payload: { channelName },
  };
}

export function handleSuccessAsyncJob(resourceId) {
  return {
    type: LIBRARY_CATEGORIES_HUB_HANDLE_SUCCESS_ASYNC_JOB,
    payload: {
      resourceId,
    },
  };
}

export function handleFailedAsyncJob(errorMessage) {
  return {
    type: LIBRARY_CATEGORIES_HUB_HANDLE_FAILED_ASYNC_JOB,
    payload: { errorMessage },
  };
}
